import { render, staticRenderFns } from "./SootSamples.vue?vue&type=template&id=14196f9a&scoped=true"
import script from "./SootSamples.vue?vue&type=script&lang=js"
export * from "./SootSamples.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14196f9a",
  null
  
)

export default component.exports